import React, { useState } from 'react';
import { useNavigate } from 'react-router';
import { Backdrop, Box, Button, Typography } from '@mui/material';
import { API, graphqlOperation } from 'aws-amplify';
import { updateDeal } from '../../../graphql/mutations';
import { GamifyToast } from '../../common/CustomToasts';

export default function DealOptionsMenu({ props }) {
  const navigate = useNavigate();
  const [showConfirmDelete, setShowConfirmDelete] = useState(false);
  // console.log('deal options menu props: ', props);
  const {
    getData,
    userId,
    searchStage,
    dealTypesCategoryIdMap,
    dealFilter,
    categoryId,
    searchString,
    fromDealPage,
    setIsLoaded,
  } = props;

  let currentOwnerID;
  let dealID;

  // for DealCard
  if (props.ourDeal) {
    currentOwnerID = props.ourDeal.currentOwnerID;
    dealID = props.ourDeal.id;
  }
  // for SelectedDeal
  if (props.currentOwnerID) {
    currentOwnerID = props.currentOwnerID;
    dealID = props.metaData.id;
  }

  // console.log('deal options dealID: ', dealID);

  const handleDeleteClick = (e) => {
    e.stopPropagation();
    setShowConfirmDelete(true);
  };

  const handleCancelDeleteClick = (e) => {
    e.stopPropagation();
    setShowConfirmDelete(false);
  };

  const handleConfirmDeleteClick = async (e, dealID) => {
    // console.log('deal options handleConfirmDeleteClick dealID: ', dealID);
    e.stopPropagation();
    e.preventDefault();
    try {
      //
      //  Delete the deal
      //
      // // deleteDealObject mutation is only in lyferize mutations file, not gamifyweb mutation file... use updateDeal w/ isDelete: true as the condtion
      // await API.graphql(
      //   graphqlOperation(mutations.deleteDealObject, {
      //     id: dealID,
      //   })
      // );
      await API.graphql(
        graphqlOperation(updateDeal, {
          input: { id: dealID, isDeleted: true },
        })
      );

      setShowConfirmDelete(false);
      GamifyToast.success(`Deal deleted successfully`);

      // reroute to /deals from the /deals/<dealID> page of the deleted deal
      navigate('/deals');

      // reload the deals data and setIsLoaded to false for showing DealListSkeleton again when deleting from DealCard, not SelectedDealDisplay
      setIsLoaded(false);
      getData(
        userId,
        searchStage,
        dealTypesCategoryIdMap[dealFilter.dealType]
          ? dealTypesCategoryIdMap[dealFilter.dealType]
          : categoryId, // pass in corresponding category id from deal type filter if it exists, otherwise use categoryId (for now it is always 'default' until searchParams implemented)
        dealFilter.dealSort,
        searchString,
        null,
        true,
        fromDealPage * 25
      );
    } catch (err) {
      GamifyToast.error(`There was an error deleting your deal`);
      console.error('deal options handleConfirmDeleteClick error: ', err);
    }
  };

  return (
    <>
      <Backdrop sx={{ zIndex: 100001 }} open={showConfirmDelete}>
        <Box className={'deal-delete-confirmation-container'}>
          <Box className={'deal-delete-confirmation-top-container'}>
            <Typography className={'deal-delete-confirmation-top-text'}>
              Are you sure you want to delete this deal?
            </Typography>
            <Typography className={'deal-delete-confirmation-bottom-text'}>
              This action cannot be undone once confirmed
            </Typography>
          </Box>
          <Box className={'deal-delete-confirmation-bottom-container'}>
            <Button
              className={'cancel-delete-deal-button'}
              onClick={(e) => handleCancelDeleteClick(e)}
              disableRipple={true}
            >
              <Typography className={'deal-delete-button-text'}>
                Cancel
              </Typography>
            </Button>
            <Button
              className={'confirm-delete-deal-button'}
              onClick={(e) => handleConfirmDeleteClick(e, dealID)}
              disableRipple={true}
            >
              <Typography className={'deal-delete-button-text'}>
                Delete
              </Typography>
            </Button>
          </Box>
        </Box>
      </Backdrop>
      <Box className={'option-menu-container'}>
        <Box className={'option-menu-edit-container'}>
          <Button
            disableRipple={true}
            className={'option-menu-top-button'}
            // onClick={(e) => handleEditClick(e)}
          >
            <Typography className={'option-menu-text'}>Edit</Typography>
          </Button>
        </Box>
        <Box className={'option-menu-change-stage-container'}>
          <Button
            disableRipple={true}
            className={'option-menu-button'}
            // onClick={(e) => handleChangeStageClick(e)}
          >
            <Typography className={'option-menu-text'}>Change Stage</Typography>
          </Button>
        </Box>
        <Box className={'option-menu-schedule-container'}>
          <Button
            disableRipple={true}
            className={
              global.me.id === currentOwnerID ||
              global.me.isAdmin ||
              global.me.functionalRoles.includes('manager')
                ? 'option-menu-button'
                : 'option-menu-bottom-button'
            }
            // onClick={(e) => handleScheduleClick(e)}
          >
            <Typography className={'option-menu-text'}>Schedule</Typography>
          </Button>
        </Box>
        {/* Only give access to delete to the deal owner, an admin, or a manager (change schedule button className also) */}
        {(global.me.id === currentOwnerID ||
          global.me.isAdmin ||
          global.me.functionalRoles.includes('manager')) && (
          <Box className={'option-menu-delete-container'}>
            <Button
              disableRipple={true}
              className={'option-menu-bottom-button'}
              onClick={(e) => handleDeleteClick(e)}
            >
              <Typography className={'option-menu-delete-text'}>
                Delete
              </Typography>
            </Button>
          </Box>
        )}
      </Box>
    </>
  );
}
